import { ModelBase } from '../../core/model/model-base';

export class LeaseAgreement extends ModelBase {
  constructor() {
    super();
  }

  statusText: string;
  leaseAgreementNumber: string;
  rentalObjectName: string;
  propertyName: string;
  rentalObjectType: string;

  toString() {
    return this.leaseAgreementNumber;
  }
}
